const Conditions = () => {
  return (
    <section className="privacy-content terms">
      <div className="overlay pt-120 pb-120">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="top-wrapper">
                <h4>
                  Syarat dan Ketentuan
                </h4>
                <p>
                  Dengan mengakses dan menggunakan website ini, Anda dianggap telah membaca, memahami, dan menyetujui Syarat dan Ketentuan berikut.

                </p>
                <h5>1. Penerimaan Syarat</h5>

                <ul>
                  <li>Dengan menggunakan website, Anda menyetujui semua aturan yang berlaku.</li>
                  <li>Jika tidak setuju, mohon untuk tidak menggunakan layanan kami.</li>
                </ul>
                <h5>2. Penggunaan Website</h5>
                <ul>
                  <li>Website hanya boleh digunakan untuk tujuan yang sah dan sesuai hukum.</li>
                  <li>Dilarang menyalahgunakan konten atau mengganggu operasional website.</li>
                  <li>Segala aktivitas yang dilakukan menjadi tanggung jawab pengguna.</li>
                </ul>

                <h5>3. Hak Kekayaan Intelektual</h5>
                <ul>
                  <li>Seluruh konten dilindungi oleh hak cipta dan hak kekayaan intelektual.</li>
                  <li>Dilarang menyalin atau menggunakan konten tanpa izin tertulis.</li>
                </ul>

                <h5>4. Batasan Tanggung Jawab</h5>
                <ul>
                  <li>Kami tidak bertanggung jawab atas kerugian akibat penggunaan website.</li>
                  <li>Kami tidak menjamin website bebas dari kesalahan teknis atau virus.</li>
                </ul>

                <h5>5. Perubahan Layanan</h5>
                <ul>
                  <li>Kami berhak mengubah, menangguhkan, atau menghentikan layanan kapan saja tanpa pemberitahuan.</li>
                </ul>

                <h5>6. Perubahan Syarat dan Ketentuan</h5>
                <ul>
                  <li>Syarat dan Ketentuan dapat diperbarui dari waktu ke waktu.</li>
                  <li>Perubahan akan diumumkan di halaman ini dengan tanggal pembaruan terbaru.</li>
                </ul>

                <h5>7. Hukum yang Berlaku</h5>
                <ul>
                  <li>Syarat dan Ketentuan ini diatur oleh hukum yang berlaku di Indonesia.</li>
                  <li>Perselisihan akan diselesaikan sesuai ketentuan hukum yang berlaku.</li>
                </ul>


                <div className="safe-data">
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Conditions;
